import { Routes } from '@angular/router';
import { createLanguageMatcher } from 'src/app/_core/utils/helpers/route.matchers';
import { PublicLayoutComponent } from 'src/app/routes/public/_layout/public.layout';
import { CART_ROUTES } from 'src/app/routes/public/modules/cart/cart.routes';
import { COOKIES_POLICY_ROUTES } from 'src/app/routes/public/modules/cookies-policy/cookies-policy.routes';
import { HOME_ROUTES } from 'src/app/routes/public/modules/home/home.routes';
import { PAYMENT_ROUTES } from 'src/app/routes/public/modules/payment/payment.routes';
import { PRIVACY_POLICY_ROUTES } from 'src/app/routes/public/modules/privacy-policy/privacy-policy.routes';
import { TICKET_ROUTES } from 'src/app/routes/public/modules/tickets/ticket.routes';
import { REGULATIONS_ROUTES } from './modules/regulations/regulations.routes';

export const PUBLIC_ROUTES: Routes = [
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      {
        matcher: createLanguageMatcher({ tickets: 'bilety' }),
        children: TICKET_ROUTES,
      },
      {
        matcher: createLanguageMatcher({ cart: 'koszyk' }),
        children: CART_ROUTES,
      },
      {
        matcher: createLanguageMatcher({
          'privacy-policy': 'polityka-prywatnosci',
        }),
        children: PRIVACY_POLICY_ROUTES,
      },
      {
        matcher: createLanguageMatcher({
          'cookies-policy': 'polityka-cookies',
        }),
        children: COOKIES_POLICY_ROUTES,
      },
      {
        matcher: createLanguageMatcher({
          regulations: 'regulamin',
        }),
        children: REGULATIONS_ROUTES,
      },
      {
        path: 'payment',
        children: PAYMENT_ROUTES,
      },
      {
        path: '',
        children: HOME_ROUTES,
      },
    ],
  },
];
